import { Injectable } from '@angular/core';
import { roundDecimals } from '@symphony-solo/shared/utils/src';
import { TransactionTaxBuilder } from '../builders';
import { TransactionTaxDto } from '../dtos';
import { TransactionProduct } from '../models';

@Injectable()
export class TransactionTaxRateGeneratorService {
  public createTransactionTaxRateList(products: TransactionProduct[]): TransactionTaxDto[] {
    const transactionTaxArray: TransactionTaxDto[] = [];
    const taxRateDictionary: { [id: number]: TransactionTaxDto } = {};

    for (const product of products) {
      const taxRate = product.taxRate;
      const dictionaryTaxRate = taxRateDictionary[product.taxRate.id];

      if (!dictionaryTaxRate) {
        taxRateDictionary[product.taxRate.id] = new TransactionTaxBuilder()
          .setTaxRate(product.taxRate.id)
          .setPercent(taxRate.percent)
          .setAmount(product.taxAmount)
          .setTotalTaxable(product.price.value)
          .build();
      } else {
        dictionaryTaxRate.amount = roundDecimals(dictionaryTaxRate.amount + product.taxAmount, 2);
        dictionaryTaxRate.totalTaxable = roundDecimals(dictionaryTaxRate.totalTaxable + product.price.value, 2);
      }
    }

    for (const taxRateId in taxRateDictionary) {
      if (taxRateDictionary[taxRateId]) {
        transactionTaxArray.push(taxRateDictionary[taxRateId]);
      }
    }

    return transactionTaxArray;
  }
}
